import { render, staticRenderFns } from "./hotRecord.vue?vue&type=template&id=74748148&scoped=true"
import script from "./hotRecord.vue?vue&type=script&lang=js"
export * from "./hotRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74748148",
  null
  
)

export default component.exports